import { Services, regExp } from '@sigma-frontend-libs/commons'

import { components, getEmptyFallback } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import sendingsCreateFallbacks from '@/components/services/sendingsCreate/fallbacks'
import sendingsCreateForm from '@/components/services/sendingsCreate/form'
import sendingsCreateRecipients from '@/components/services/sendingsCreate/recipients'

function renderTitle(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${Services.templates}.labels.title`),
        required: true,
        autofocus: true,
        details: false,
        mask: regExp.varchar
      },
      on: {
        input: event => {
          this.proxy.title = event
        },
        keypress: event => {
          if (event.keyCode === 13) {
            this.$emit('submit', this.proxy)
          }
        }
      }
    }
  )
}
function renderOwnerSelect(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.templates}-form__row-fields`]: true,
        [`${Services.templates}-form__row-fields--admin`]: this.canGetUsers
      }
    },
    [
      renderTitle.call(this, h),
      renderOwnerSelect.call(this, h)
    ]
  )
}
function renderIsActive(h) {
  if (this.canCreateTemplates || this.canUpdateTemplates) {
    return h(
      'div',
      {
        class: `${Services.templates}-form__row-switch`
      },
      [
        h(
          components.switch,
          {
            props: {
              value: this.proxy.isActive,
              tooltip: this.getTranslate(`${Services.templates}.tooltips.isActive`)
            },
            on: {
              input: event => {
                this.proxy.isActive = event
              }
            }
          }
        )
      ]
    )
  }
}
function renderTemplateBasicFields(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-form__row`
    },
    [
      renderFields.call(this, h),
      renderIsActive.call(this, h)
    ]
  )
}

function renderSendingsCreateRecipients(h) {
  return h(
    sendingsCreateRecipients,
    {
      props: {
        value: this.proxy.recipient
      },
      on: {
        input: event => {
          this.proxy.recipient = event
        }
      }
    }
  )
}
function renderSendingForm(h) {
  if (!this.hasFallbacks) {
    return h(
      sendingsCreateForm,
      {
        props: {
          value: this.proxy,
          service: Services.templates
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      }
    )
  }
}
function renderFallbacks(h) {
  return h(
    sendingsCreateFallbacks,
    {
      props: {
        value: this.proxy,
        defaultValue: getEmptyFallback(),
        service: Services.templates
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-form`
    },
    [
      renderTemplateBasicFields.call(this, h),
      renderSendingsCreateRecipients.call(this, h),
      renderSendingForm.call(this, h),
      renderFallbacks.call(this, h)
    ]
  )
}
